import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientRelations } from 'src/app/models/client-relations';
import { ShareService } from '../services/share-service';
import { AccountService } from 'src/app/application/account/account.service';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-client-relation-popup',
  templateUrl: './client-relation-popup.component.html',
  styleUrls: ['./client-relation-popup.component.scss']
})
export class ClientRelationPopupComponent {
  @ViewChild('content') addview !: ElementRef
  @Output() dataAdded: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: NgbModal, private apiService:AccountService,private shareService: ShareService,
    private ngbDateParserFormatter: NgbDateParserFormatter) { }

  ngOnInit(): void {
    this.loadRelationTypes();
  }

  errormessage = '';
  errorclass = '';
  saveresponse: any;
  relationData: ClientRelations;
  editdata: any;
  relationTypes:any;
  selected_start_date: NgbDate;
  start_date: string;
  selected_end_date: NgbDate;
  end_date: string;

  public selectedDate: NgbDate;
  public dateObject: Date;

  relationform = new FormGroup({
    id:new FormControl(),
    relation_name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(5)])),
    relation_start_date: new FormControl('', Validators.compose([Validators.required])),
    relation_end_date: new FormControl(),
    relation_address:new FormControl(),
    relation_phone: new FormControl(),
    relation_type: new FormControl()
  });

  saveRelation(){
    if(this.relationform.valid){
      console.log("relation data "+JSON.stringify(this.relationform.value));
      this.relationData = new ClientRelations(this.relationform.value);
      this.relationData.client_id = this.shareService.getLinkedClientId();
      
      this.relationData.relation_start_date = this.start_date;
      this.relationData.relation_end_date =this.end_date;

      // console.log("relation data "+JSON.stringify(this.relationData));

      this.apiService.saveClientRelation(this.relationData).then(res =>{
        // console.log("response "+JSON.stringify(res));
        if(res["status"] == 1){
          this.closeModalForm();
          // this.
          this.dataAdded.emit();
        }
      })
    }
    else{
      this.errormessage = "Please enter valid data";
      this.errorclass = "errormessage";
    }
  }

  loadEditData(id: any){
    this.openModalForm();
    this.apiService.getClientRelation(id).then(result => {
      // console.log("relation details "+JSON.stringify(result));
      var relation = result["data"];
      // relation["relation_start_date"] = new Date(relation["relation_start_date"]);
      // relation["relation_end_date"] = new Date(relation["relation_end_date"]);
      // console.log("relation details "+JSON.stringify(relation));

      const relationStartDate = NgbDate.from(this.ngbDateParserFormatter.parse(relation.relation_start_date));
      const relationEndDate = NgbDate.from(this.ngbDateParserFormatter.parse(relation.relation_end_date));

      this.relationform.patchValue(
        { id:relation.id,
          relation_name: relation.relation_name,
          // relation_start_date: relationStartDate,
          relation_end_date: relationEndDate,
          relation_address: relation.relation_address,
          relation_phone: relation.relation_phone,
          relation_type: relation.relation_type
      });
      this.updateStartDate(relationStartDate);
      this.updateEndDate(relationEndDate);
    });
  }

  deleteRelation(id:number){
    this.apiService.deleteClientRelation(id).then(result=>{
      if(result["status"] == 1){
        // this.closeModalForm();
        this.dataAdded.emit();
      }
    })
  }

  updateStartDate(date: NgbDate){
    this.start_date = Utils.yearMonthDay(new Date(date.year,date.month,date.day));
  }

  updateEndDate(date: NgbDate){
    this.end_date = Utils.yearMonthDay(new Date(date.year,date.month,date.day));
  }



  openModalForm(){
    this.clearForm();
    this.modalService.open(this.addview,{ ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModalForm(){
    this.clearForm();
    this.modalService.dismissAll();
  }

  clearForm(){
    this.relationform.patchValue({id:null,relation_name:"",relation_start_date:"",relation_end_date:"",relation_phone:"",relation_type:"",
  relation_address:""});
  }

  loadRelationTypes(){
    this.apiService.getRelationTypesDll().then(res =>{
      this.relationTypes = res;
    });
  }

  
}
